import React from 'react'
import {Link} from "react-router-dom"
import {objectLang, setLocalStorageItem} from "../functions"

export class MoneySettingsClass extends React.Component {

    render() {

        const {settings, removeHandler} = this.props

        const lang = objectLang().language
        const l = lang.lang

        const cardsDB = settings['cards']

        const cards = []
        for (const i in cardsDB) {
            let currency = cardsDB[i][3], dateExp = cardsDB[i][4]
            if (!isNaN(Number(cardsDB[i][3]))) {
                currency = settings['currencies'][Number(cardsDB[i][3])]
            }
            if (!isNaN(Number(cardsDB[i][4]))) {
                dateExp = String(new Date(Number(cardsDB[i][4])).getDate())
            } else {
                dateExp = lang.body.moneySettingsPage.oneSameDay
            }
            cards[i] = {
                cardId: cardsDB[i][0],
                name: cardsDB[i][1],
                type: cardsDB[i][2],
                currency: currency,
                dateExp: dateExp,
                defaultType: cardsDB[i][5],
            }
        }

        return (
            <>
                <div className={"mt-2 col col-sm-12 col-lg-12 col-xl-9 d-flex justify-content-center m-auto"}>
                    <div className={"row"}>

                        <div
                            className={'mb-2 col col-sm-11 col-lg-12 col-xl-12 d-flex flex-wrap justify-content-start'}>
                            <Link id={'back'}
                                  to={`/${l}/money/main`}
                                  type={'button'}
                                  className={'col btn btn-success m-1 fs-6 p-sm-1 p-2 d-flex align-items-center justify-content-center'}>
                                <i className="fa-solid fa-arrow-left"/>
                            </Link>
                            <Link id={'add-card'}
                                  to={`/${l}/money/add-card`}
                                  type={'button'}
                                  className={'col btn btn-success m-1 fs-6 p-sm-1 p-2 d-flex align-items-center justify-content-center'}>
                                {lang.body.moneyPage.main.addCard}
                            </Link>
                            <Link id={'add-bank'}
                                  to={`/${l}/money/add-bank`}
                                  type={'button'}
                                  className={'col btn btn-success m-1 fs-6 p-sm-1 p-2 d-flex align-items-center justify-content-center disabled'}>
                                {lang.body.moneyPage.main.addBank}
                            </Link>
                            <Link id={'set-currency'}
                                  to={`/${l}/money/set-currency`}
                                  type={'button'}
                                  className={'col btn btn-success m-1 fs-6 p-sm-1 p-2 d-flex align-items-center justify-content-center d-none'}>
                                {lang.body.moneyPage.main.setCurrency}
                            </Link>
                            <div className={'col d-lg-flex align-items-center justify-content-center d-none'}>
                            </div>
                            <div className={'col d-lg-flex align-items-center justify-content-center d-none'}>
                            </div>
                            <div className={'col d-lg-flex align-items-center justify-content-center d-none'}>
                            </div>
                        </div>

                        {cards.map((card, index) => {
                            const c = {
                                name: card['name'],
                                type: lang.body.moneyPage[`cardType${card['type']}`],
                                dateExp: card['dateExp'],
                                currency: card['currency'],
                                defaultType: card['defaultType'],
                                cardId: card['cardId']
                            }
                            if (c.name === 'Cash') {
                                c.name = lang.body.moneyPage.cardTypeCash
                            }
                            setLocalStorageItem(c.cardId, c)

                            return (
                                <div className={"col-xs-6 col-sm-6 col-lg-6"} key={index}>
                                    <div className={"card mb-2"}>
                                        <div className={"card-body"}>
                                            <div className={'col col-12 border-bottom d-flex flex-nowrap'}>
                                                <h5 className={"card-title pb-1 col-9"}>{c.name}</h5>
                                                {c.type !== lang.body.moneyPage.cardTypeCash &&
                                                <Link to={``}
                                                      className={'card-title col-2 me-3 text-decoration-none text-danger fw-bold'}>
                                                    <i id={`income-i-icon-remove-${index}`}
                                                       className={"fa-solid fa-trash-can d-flex align-items-center justify-content-end text-danger"}
                                                       onClick={() => {
                                                           removeHandler(c.cardId)
                                                       }}
                                                    />
                                                </Link>}
                                                {c.type !== lang.body.moneyPage.cardTypeCash &&
                                                <Link to={`/${lang.lang}/money/card/update?cardId=${c.cardId}`}
                                                      className={'card-title col text-decoration-none text-primary'}>
                                                    <i id={`income-i-icon-update-${index}`}
                                                       className={"fa-solid fa-pen-to-square d-flex align-items-center"}
                                                    />
                                                </Link>}
                                            </div>

                                            <div className={"d-flex m-0"}>
                                                <div className={"p-1 w-75"}>{lang.body.moneySettingsPage.defaults}</div>
                                                <div className={"p-1 w-50 flex-shrink-1"}>
                                                    <input type={'checkbox'}
                                                           className={"form-check-input"}
                                                           defaultChecked={c.defaultType}
                                                           disabled={true}/>
                                                </div>
                                            </div>
                                            <div className={"d-flex m-0"}>
                                                <div
                                                    className={"p-1 w-75"}>{lang.body.moneySettingsPage.typePayment}</div>
                                                <div className={"p-1 w-50 flex-shrink-1"}>
                                                    <strong className={"m-0 text-success"}>{c.type}</strong>
                                                </div>
                                            </div>
                                            <div className={"d-flex m-0"}>
                                                <div
                                                    className={"p-1 w-75"}>{lang.body.moneySettingsPage.debitDate}</div>
                                                <div className={"p-1 w-50 flex-shrink-1"}>
                                                    <strong className={"m-0 text-success"}>{c.dateExp}</strong>
                                                </div>
                                            </div>
                                            <div className={"d-flex m-0"}>
                                                <div
                                                    className={"p-1 w-75"}>{lang.body.moneySettingsPage.currencyCard}</div>
                                                <div className={"p-1 w-50 flex-shrink-1"}>
                                                    <strong className={"m-0 text-success"}>{c.currency}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </>
        )
    }
}
